export function getSiimilarGeoObjectId(id: string): string {
  return `similar-${id}`;
}
